import axios from 'axios';
import { getChannelToken_v1 } from 'js/library/utils/API/getChannelToken_v1';
import cfac22 from '../cfac22';

export function preferentialAddress(uId, origin, type, zipCode) {
  return new Promise((resolve, reject) => {
    if (zipCode) {
      getChannelToken_v1(uId)
        .then((result) => {
          //console.log('RESULTADO GET CHANNEL TOKEN ===>', result);
          axios
            .post(
              cfac22('API_HOST_V1') + 'preferentialAddress',
              {
                triiboHeader: {
                  apiToken: cfac22('apiToken'),
                  channelGroup: cfac22('channelGroup'),
                  channelName: cfac22('channelName'),
                  uId: uId,
                  channelTokenId: result,
                  channelId: cfac22('channelId'),
                  sessionId: '001',
                  transactionId: '002',
                },
                uId,
                addresses: [
                  {
                    origin,
                    type,
                    zipCode,
                  },
                ],
              },
              {
                headers: {
                  'Full-Url': window.location.href,
                },
              }
            )
            .then((result) => {
              //console.log('RESULTADO PREFERENTIAL ADDRESS ===>', result);
              resolve(result.data);
            })
            .catch((error) => {
              //console.log('ERROR PREFERENTIAL ADDRESS ---->', error.response);
              reject(error);
            });
        })
        .catch((error) => {
          //console.log('ERROR GET CHANNEL TOKEN ---->', error);
          reject(error);
        });
    } else {
      resolve(null);
    }
  });
}
